import { getBackendUrl } from "@/lib/backend";
import axios from "axios";

export const API = `${getBackendUrl()}/api`;

// Configure axios to always include credentials (cookies) so the
// session_token cookie set by /api/auth/session is sent back automatically.
axios.defaults.withCredentials = true;

// ---- Double-submit CSRF token (backend SEC-001 defence-in-depth) ----
// The backend `CsrfDoubleSubmitMiddleware` sets a non-HttpOnly
// `csrf_token` cookie on every response and requires an
// `X-CSRF-Token` header on unsafe-method requests carrying a session
// cookie. This interceptor reads the cookie and echoes it in the
// header so all POST/PUT/PATCH/DELETE requests are auto-signed.
const UNSAFE_METHODS = new Set(["post", "put", "patch", "delete"]);

function readCookie(name) {
  if (typeof document === "undefined") return "";
  const target = name + "=";
  const parts = document.cookie ? document.cookie.split("; ") : [];
  for (const p of parts) {
    if (p.startsWith(target)) return decodeURIComponent(p.slice(target.length));
  }
  return "";
}

axios.interceptors.request.use((config) => {
  const method = (config.method || "get").toLowerCase();
  if (UNSAFE_METHODS.has(method)) {
    const token = readCookie("csrf_token");
    if (token) {
      config.headers = config.headers || {};
      // Never overwrite an explicit header (e.g. test fixtures).
      if (!config.headers["X-CSRF-Token"] && !config.headers["x-csrf-token"]) {
        config.headers["X-CSRF-Token"] = token;
      }
    }
  }
  return config;
});

export default axios;
